// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","453":"54292a4b","455":"39016624","762":"5ac82a1b","857":"03a170dd","977":"b584b783"}[chunkId] + ".chunk.js";
};